import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeploymentSettings = () => {
  const [isDeploying, setIsDeploying] = useState(false);

  const currentDeployment = {
    status: 'live',
    version: 'v2.4.1',
    deployedAt: '2025-12-26 14:30:00',
    deployedBy: 'John Doe',
    branch: 'main',
    commitHash: 'a3f5c2d',
    buildTime: '2m 34s'
  };

  const deploymentHistory = [
    {
      id: 1,
      version: 'v2.4.1',
      status: 'success',
      deployedAt: '2025-12-26 14:30:00',
      deployedBy: 'John Doe',
      branch: 'main',
      commitHash: 'a3f5c2d',
      buildTime: '2m 34s',
      message: 'Updated product catalog and fixed checkout bug'
    },
    {
      id: 2,
      version: 'v2.4.0',
      status: 'success',
      deployedAt: '2025-12-25 10:15:00',
      deployedBy: 'Sarah Johnson',
      branch: 'main',
      commitHash: 'b7e9f1a',
      buildTime: '2m 18s',
      message: 'Added new payment gateway integration'
    },
    {
      id: 3,
      version: 'v2.3.9',
      status: 'failed',
      deployedAt: '2025-12-24 16:45:00',
      deployedBy: 'Michael Chen',
      branch: 'develop',
      commitHash: 'c4d8e2b',
      buildTime: '1m 52s',
      message: 'Performance optimizations'
    },
    {
      id: 4,
      version: 'v2.3.8',
      status: 'success',
      deployedAt: '2025-12-23 09:20:00',
      deployedBy: 'John Doe',
      branch: 'main',
      commitHash: 'd9f3a5c',
      buildTime: '2m 45s',
      message: 'UI improvements and bug fixes'
    }
  ];

  const handleDeploy = () => {
    setIsDeploying(true);
    setTimeout(() => {
      setIsDeploying(false);
    }, 3000);
  };

  const handleRollback = (version) => {
    console.log('Rolling back to version:', version);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'success': case'live':
        return 'bg-success/10 text-success border-success/20';
      case 'failed':
        return 'bg-destructive/10 text-destructive border-destructive/20';
      case 'pending':
        return 'bg-warning/10 text-warning border-warning/20';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'success': case'live':
        return 'CheckCircle';
      case 'failed':
        return 'XCircle';
      case 'pending':
        return 'Clock';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="space-y-6 md:space-y-8">
      <div className="bg-card rounded-lg border border-border p-4 md:p-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
          <div>
            <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground">
              Current Deployment
            </h3>
            <p className="text-sm text-muted-foreground mt-1">
              Live production environment status
            </p>
          </div>
          <Button
            variant="default"
            size="sm"
            iconName="Rocket"
            iconPosition="left"
            onClick={handleDeploy}
            loading={isDeploying}
          >
            {isDeploying ? 'Deploying...' : 'Deploy Now'}
          </Button>
        </div>

        <div className="p-4 bg-success/10 border border-success/20 rounded-lg mb-4">
          <div className="flex items-center gap-2 mb-3">
            <Icon name="CheckCircle" size={24} className="text-success" />
            <span className="caption font-semibold text-success">Production is Live</span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <p className="text-xs text-muted-foreground mb-1">Version</p>
              <p className="caption font-medium text-foreground">{currentDeployment?.version}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Deployed At</p>
              <p className="caption font-medium text-foreground">{currentDeployment?.deployedAt}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Deployed By</p>
              <p className="caption font-medium text-foreground">{currentDeployment?.deployedBy}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Build Time</p>
              <p className="caption font-medium text-foreground">{currentDeployment?.buildTime}</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <div className="p-3 bg-background border border-border rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="GitBranch" size={16} className="text-primary" />
              <span className="text-xs text-muted-foreground">Branch</span>
            </div>
            <p className="caption font-medium text-foreground font-mono">{currentDeployment?.branch}</p>
          </div>
          <div className="p-3 bg-background border border-border rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="GitCommit" size={16} className="text-primary" />
              <span className="text-xs text-muted-foreground">Commit</span>
            </div>
            <p className="caption font-medium text-foreground font-mono">{currentDeployment?.commitHash}</p>
          </div>
          <div className="p-3 bg-background border border-border rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Activity" size={16} className="text-primary" />
              <span className="text-xs text-muted-foreground">Status</span>
            </div>
            <p className="caption font-medium text-success capitalize">{currentDeployment?.status}</p>
          </div>
        </div>
      </div>
      <div className="bg-card rounded-lg border border-border p-4 md:p-6">
        <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground mb-4 md:mb-6">
          Deployment History
        </h3>
        
        <div className="space-y-3">
          {deploymentHistory?.map((deployment) => (
            <div
              key={deployment?.id}
              className="p-4 bg-background border border-border rounded-lg hover:shadow-sm transition-all duration-250"
            >
              <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="caption font-semibold text-foreground font-mono">
                      {deployment?.version}
                    </span>
                    <span className={`px-2 py-1 rounded text-xs font-medium border ${getStatusColor(deployment?.status)}`}>
                      <Icon name={getStatusIcon(deployment?.status)} size={12} className="inline mr-1" />
                      {deployment?.status}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      {deployment?.branch}
                    </span>
                  </div>
                  <p className="text-sm text-foreground mb-2">{deployment?.message}</p>
                  <div className="flex flex-wrap items-center gap-3 text-xs text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <Icon name="User" size={12} />
                      {deployment?.deployedBy}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="Clock" size={12} />
                      {deployment?.deployedAt}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="Timer" size={12} />
                      {deployment?.buildTime}
                    </span>
                    <span className="flex items-center gap-1 font-mono">
                      <Icon name="GitCommit" size={12} />
                      {deployment?.commitHash}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-2 w-full lg:w-auto">
                  {deployment?.status === 'success' && deployment?.id !== 1 && (
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => handleRollback(deployment?.version)}
                      iconName="RotateCcw"
                      iconPosition="left"
                      className="flex-1 lg:flex-none"
                    >
                      Rollback
                    </Button>
                  )}
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="ExternalLink"
                    className="flex-1 lg:flex-none"
                  >
                    View
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-lg border border-border p-4 md:p-6">
        <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground mb-4 md:mb-6">
          Deployment Configuration
        </h3>
        
        <div className="space-y-4">
          <div className="p-4 bg-background border border-border rounded-lg">
            <div className="flex items-start justify-between mb-3">
              <div>
                <p className="caption font-medium text-foreground mb-1">Auto Deploy</p>
                <p className="text-sm text-muted-foreground">
                  Automatically deploy when changes are pushed to main branch
                </p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" className="sr-only peer" defaultChecked />
                <div className="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
              </label>
            </div>
          </div>

          <div className="p-4 bg-background border border-border rounded-lg">
            <div className="flex items-start justify-between mb-3">
              <div>
                <p className="caption font-medium text-foreground mb-1">Build Notifications</p>
                <p className="text-sm text-muted-foreground">
                  Receive email notifications for deployment status
                </p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" className="sr-only peer" defaultChecked />
                <div className="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
              </label>
            </div>
          </div>

          <div className="p-4 bg-background border border-border rounded-lg">
            <p className="caption font-medium text-foreground mb-3">Build Command</p>
            <code className="block p-3 bg-muted border border-border rounded text-sm font-mono text-foreground">
              npm run build
            </code>
          </div>

          <div className="p-4 bg-background border border-border rounded-lg">
            <p className="caption font-medium text-foreground mb-3">Output Directory</p>
            <code className="block p-3 bg-muted border border-border rounded text-sm font-mono text-foreground">
              dist
            </code>
          </div>
        </div>
      </div>
      <div className="bg-warning/10 border border-warning/20 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <Icon name="AlertTriangle" size={24} className="text-warning mt-0.5 flex-shrink-0" />
          <div>
            <p className="caption font-medium text-warning mb-1">Deployment Best Practices</p>
            <ul className="text-sm text-muted-foreground space-y-1 list-disc list-inside">
              <li>Always test changes in a staging environment before deploying to production</li>
              <li>Review deployment history and rollback if issues are detected</li>
              <li>Monitor performance metrics after each deployment</li>
              <li>Keep deployment logs for troubleshooting and audit purposes</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeploymentSettings;